var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmexSmallLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9999 6.48438H16.7036V9.72673H21.9999V6.48438Z",
    fill: "#FBAF33"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9998 0H11.4072L12.0693 3.24236H21.9998V0Z",
    fill: "#FBAF33"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9998 12.9697H12.7313L11.4072 16.2121H21.9998V12.9697Z",
    fill: "#FBAF33"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.70368 6.48438H0V9.72673H5.70368V6.48438Z",
    fill: "#FBAF33"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.17523 6.55213C7.3015 5.22418 8.33822 3.09069 10.9583 3.09069C13.5783 3.09069 14.5137 5.04217 14.5669 6.5437L7.17523 6.55213ZM18.3632 9.417C18.4531 8.53686 18.4531 7.64966 18.3632 6.76952L18.3333 6.54876C17.7352 2.03069 14.4655 0 11.0679 0C6.65355 0 3.25928 3.11091 3.25928 8.21376C3.25928 13.1211 6.59041 16.2118 11.0829 16.2118C14.738 16.2118 17.0905 13.5778 17.6504 11.8471H13.6963C12.9935 12.7082 11.9618 13.1194 10.8536 13.1194C8.62232 13.1194 7.29153 11.387 7.15862 9.62091H18.3383L18.3632 9.417Z",
    fill: "#1D1D1B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmexSmallLogo);
export default __webpack_public_path__ + "static/media/EmexSmallLogo.362ca8b6.svg";
export { ForwardRef as ReactComponent };